import React from "react";
import Slider from "react-slick";
import LeftArrow from "assets/svgIcons/AdminDashboard/SliderLeftArrow";
import RightArrow from "assets/svgIcons/AdminDashboard/SliderRightArrow";
import styled from "styled-components";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Box } from "@mui/system";
import { FormControl, NativeSelect } from "@mui/material";
import { useState } from "react";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import {
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getDashboardCampaignAdsStateAction } from "../../../../redux/reduxToolkitServices/_commonReducers/commonReducers";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useRedirectToPage } from "commonComponents/Navigation";
function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <RightArrow />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <LeftArrow />
    </div>
  );
}

export const CampaignAds = () => {
  const { t } = useTranslation();
  const redirectToPage = useRedirectToPage();
  const dispatch = useDispatch();
  const { sideDrawerActiveTabState, subNavDataState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const navigate = useNavigate();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [dropDownValue, setDropDownValue] = useState("full");
  const {
    getDashboardCampaignAdsState,
    getDashboardFullImagesDataState,
    getDashboardInsertImagesDataState,
    getDashboardFeatureSetStatus,
    siteSettingsData,
  } = useSelector((state) => state.commonReducers) || [];

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const currQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");
      dispatch(getDashboardCampaignAdsStateAction([]));
      dispatch(
        COMMON_SERVICES.getDashboardCampaignAdsServices(
          siteId.get(),
          currQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  useEffect(() => {
    let data =
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
        getDashboardCampaignAdsState &&
        getDashboardCampaignAdsState.length !== 0 &&
        getDashboardCampaignAdsState !== undefined &&
        getDashboardCampaignAdsState !== null
        ? getDashboardCampaignAdsState?.forEach((item) => {
          if (item?.fullPage === true) {
            dispatch(COMMON_SERVICES.getDashboardFullImagesServices(item));
          }
        })
        : dispatch(COMMON_SERVICES.resetDashboardFUllAdImageDataServices());
  }, [getDashboardFeatureSetStatus, getDashboardCampaignAdsState]);

  useEffect(() => {
    let data =
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
        getDashboardCampaignAdsState &&
        getDashboardCampaignAdsState.length !== 0 &&
        getDashboardCampaignAdsState !== undefined &&
        getDashboardCampaignAdsState !== null
        ? getDashboardCampaignAdsState?.forEach((item) => {
          if (item?.fullPage === false) {
            dispatch(COMMON_SERVICES.getDashboardInsertImagesServices(item));
          }
        })
        : dispatch(COMMON_SERVICES.resetDashboardInsertAdImageDataServices());
  }, [getDashboardFeatureSetStatus, getDashboardCampaignAdsState]);

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <>
      <Box sx={{
        minWidth: {
          xs: 90,   //for 0–600px
          sm: 100,   //for 600–820px
          md: 120,  //for >820px
        }
      }}>
        <FormControl fullWidth>
          <NativeSelect
            defaultValue="full"
            onChange={(e) => setDropDownValue(e.target.value)}
          >
            <option value="full">{t("Full")}</option>
            <option value="insert">{t("Insert")}</option>
          </NativeSelect>
        </FormControl>
      </Box>
      <SliderContainer>
        {dropDownValue === "full" &&
          getDashboardFullImagesDataState &&
          getDashboardFullImagesDataState?.length > 0 ? (
          <Slider {...settings}>
            {getDashboardFullImagesDataState?.map((el, index) => {
              return (
                <ImageWrapper
                  onClick={() => redirectToPage("today-camp-ads")}
                  key={`${el.base64data}_${index}`}
                >
                  <div>
                    <img src={el?.base64data} alt="ads" />
                  </div>
                </ImageWrapper>
              );
            })}
          </Slider>
        ) : (
          <></>
        )}

        {dropDownValue === "insert" &&
          getDashboardInsertImagesDataState &&
          getDashboardInsertImagesDataState?.length > 0 ? (
          <Slider {...settings}>
            {getDashboardInsertImagesDataState?.map((el, index) => {
              return (
                <ImageWrapper
                  onClick={() => redirectToPage("today-camp-ads")}
                  key={`${index}_${el.base64data}`}
                >
                  <div>
                    <img src={el?.base64data} alt="ads" />
                  </div>
                </ImageWrapper>
              );
            })}
          </Slider>
        ) : (
          <></>
        )}
      </SliderContainer>
    </>
  );
};

const SliderContainer = styled.div`
  .slick-next,
  .slick-prev {
    width: 18px;
    height: 30px;
    ::before {
      display: none;
    }
  }
  .slick-prev {
    left: -55px;
  }
  .slick-next {
    right: -55px;
  }
`;

const ImageWrapper = styled.div`
  > div {
    margin: 35px 22px;
    img {
      width: 100%;
      max-width: 100%;
      border: 1px solid #ffffff;
      border-radius: 20px;
    }
  }
`;
